export class ExecutorDisbursementLiabilityMeta {
  //
}
